var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Component, ViewEncapsulation } from '@angular/core';
import { AuthService } from './auth.service';
var AuthComponent = (function () {
    function AuthComponent(authService, translate, router) {
        this.authService = authService;
        this.translate = translate;
        this.router = router;
    }
    AuthComponent.prototype.ngOnInit = function () {
        this.acceptTerms = false;
        this.loginError = false;
        this.loginErrorSuccess = false;
    };
    AuthComponent.prototype.changeForm = function (event, target) {
        jQuery('.authform').hide();
        jQuery(target).show();
        jQuery('.tabs div').removeClass('active');
        event.target.classList.add('active');
    };
    AuthComponent.prototype.login = function () {
        var _this = this;
        this.loginError = false;
        this.authService.login(this.loginEmail, this.loginPassword)
            .then(function () { return _this.router.navigate(['/dashboard']); })
            .catch((function (err) {
            var _this = this;
            if (err.code == 'invalid_grant')
                this.translate.get('LOGIN.ERROR.INVALID_GRANT').subscribe(function (res) { return _this.loginErrorMessage = res; });
            else
                this.translate.get('LOGIN.ERROR.GENERIC_ERROR').subscribe(function (res) { return _this.loginErrorMessage = res; });
            this.loginErrorSuccess = false;
            this.loginError = true;
        }).bind(this));
    };
    AuthComponent.prototype.signup = function () {
        var _this = this;
        this.loginError = false;
        this.authService.signup(this.subEmail, this.subPassword)
            .then(function (result) { return _this.authService.login(_this.subEmail, _this.subPassword).then(function () { return _this.router.navigate(['/dashboard']); }); })
            .catch((function (err) {
            var _this = this;
            this.translate.get('LOGIN.ERROR.USER_EXISTS').subscribe(function (res) { return _this.loginErrorMessage = res; });
            this.loginErrorSuccess = false;
            this.loginError = true;
        }).bind(this));
    };
    AuthComponent.prototype.changePassword = function () {
        var _this = this;
        this.loginError = false;
        this.loginErrorSuccess = false;
        this.authService.changePassword(this.loginEmail)
            .then(function (result) {
            _this.translate.get('LOGIN.ERROR.RESET_PASSWORD_SENT').subscribe(function (res) {
                _this.loginErrorMessage = res;
                _this.loginErrorSuccess = true;
                _this.loginError = true;
            });
        })
            .catch((function (err) {
            var _this = this;
            this.translate.get('LOGIN.ERROR.EMAIL_REQUIRED').subscribe(function (res) { return _this.loginErrorMessage = res; });
            this.loginError = true;
        }).bind(this));
    };
    AuthComponent = __decorate([
        Component({
            selector: 'cx-login',
            templateUrl: './auth.component.html',
            encapsulation: ViewEncapsulation.None,
            styles: [require('./auth.component.css').toString()]
        }),
        __metadata("design:paramtypes", [AuthService, TranslateService, Router])
    ], AuthComponent);
    return AuthComponent;
}());
export { AuthComponent };
//# sourceMappingURL=auth.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/auth.component.js
// module id = 592
// module chunks = 0